
import { Injectable, Output, EventEmitter, OnInit } from "@angular/core";
@Injectable()
export class SharedDataService{
    
    constructor() {}
   
    @Output() value = new EventEmitter();
    UpdateValue(val){
        this.value.emit(val);
    }
    
}